{
  "name": "the-learing-lab",
  "version": "8.15.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --deploy-url /assets/versioned-assets/8.15.3/ --aot --configuration=development",
    "build:staging": "ng build --deploy-url /assets/versioned-assets/8.15.3/ --aot --configuration=staging",
    "build:prod": "ng build --deploy-url /assets/versioned-assets/8.15.3/ --aot --configuration=production",
    "build:scorm": "ng run the-learning-lab:build-scorm",
    "start:pwa": "ng build --aot --configuration production && http-server ./dist -p 8081",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "bundle-report": "ng build --stats-json && webpack-bundle-analyzer dist/stats.json; npm run analyze",
    "analyze": "webpack-bundle-analyzer dist/stats-es2015.json",
    "prevbuild": "node prevbuild.js",
    "postbuild": "node postbuild.js",
    "link:library-explorer": "cd ../../shared && yarn && yarn build && cd ./dist/library-explorer && yarn link && cd ../../../apps/frontend && yarn link 'library-explorer'",
    "watch:lib": "cd ../../shared && yarn build --watch",
    "appflow:build": "bash appflow-prepare-build.sh && ng build --aot --configuration=$BUILD_ENV",
    "generate-scorm-package-export": "yarn build:scorm && node postbuild-scorm-package.js"
  },
  "private": true,
  "dependencies": {
    "@altack/ngx-onetrust": "^1.5.0",
    "@angular/animations": "^22.1.4",
    "@angular/cdk": "^22.1.4",
    "@angular/common": "^22.1.4",
    "@angular/compiler": "^22.1.4",
    "@angular/core": "^22.1.4",
    "@angular/forms": "^22.1.4",
    "@angular/material": "^22.1.4",
    "@angular/platform-browser": "^22.1.4",
    "@angular/platform-browser-dynamic": "^22.1.4",
    "@angular/pwa": "^22.1.6",
    "@angular/router": "^22.1.4",
    "@angular/service-worker": "^22.1.4",
    "@angular/youtube-player": "^22.1.4",
    "@aparajita/capacitor-biometric-auth": "^8.0.0",
    "@aparajita/capacitor-secure-storage": "^6.0.0",
    "@apollo/client": "^3.0.0",
    "@capacitor-community/file-opener": "^1.0.5",
    "@capacitor-community/keep-awake": "^4.0.0",
    "@capacitor-community/safe-area": "^7.0.0",
    "@capacitor/android": "^7.4.1",
    "@capacitor/app": "^5.0.2",
    "@capacitor/app-launcher": "^6.0.2",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/browser": "^6.0.4",
    "@capacitor/clipboard": "^6.0.1",
    "@capacitor/core": "^7.4.1",
    "@capacitor/device": "^5.0.7",
    "@capacitor/filesystem": "^5.1.4",
    "@capacitor/ios": "6.2.1",
    "@capacitor/keyboard": "^6.0.2",
    "@capacitor/push-notifications": "^5.1.1",
    "@capacitor/share": "^6.0.2",
    "@capawesome/capacitor-app-update": "^6.0.0",
    "@capgo/capacitor-updater": "^6.0.32",
    "@capgo/inappbrowser": "^6.8.18",
    "@ckeditor/ckeditor5-angular": "^11.1.2",
    "@google/model-viewer": "1.3.0",
    "@messageformat/core": "^3.4.0",
    "@ng-select/ng-select": "^23.5.1",
    "@ngx-matomo/router": "4.1.2",
    "@ngx-matomo/tracker": "^4.1.2",
    "@ngx-pwa/local-storage": "^22.0.0",
    "@ngx-pwa/offline": "^13.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@panzoom/panzoom": "^4.5.1",
    "@sentry/browser": "^9.2.0",
    "@sentry/webpack-plugin": "^1.18.9",
    "@stripe/stripe-js": "^1.11.0",
    "@swimlane/ngx-charts": "^25.0.1",
    "@trapezedev/configure": "^7.0.10",
    "@types/video.js": "^7.3.17",
    "@types/vimeo__player": "^2.18.0",
    "@vimeo/player": "^2.15.0",
    "adaptivecards": "^3.0.5",
    "add-to-calendar-button": "^2.8.3",
    "angular-code-input": "^2.0.0",
    "angular-svg-icon": "^16.1.0",
    "angular2-hotkeys": "^16.0.1",
    "animate.css": "^4.1.1",
    "aws-appsync-subscription-link": "3.1.3",
    "capacitor-blob-writer": "^1.1.14",
    "capacitor-ios-autofill-save-password": "^4.0.0",
    "capacitor-plugin-app-tracking-transparency": "^2.0.4",
    "ckeditor5": "47.6.2",
    "color": "^3.1.2",
    "core-js": "^2.6.9",
    "d3-shape": "^3.2.0",
    "dompurify": "^3.1.6",
    "file-saver": "^2.0.5",
    "graphql": "^16.13.2",
    "hls.js": "1.3.5",
    "jquery": "^3.5.0",
    "js-yaml": "^4.0.0",
    "jszip": "^3.10.1",
    "jwt-decode": "^2.2.0",
    "lottie-web": "^5.12.2",
    "messageformat": "^2.3.0",
    "moment": "^2.29.1",
    "moment-timezone": "^0.5.33",
    "ng-click-outside2": "^12.0.0",
    "ngx-device-detector": "^12.0.0",
    "ngx-doc-viewer": "^15.0.1",
    "ngx-ellipsis": "^5.0.2",
    "ngx-extended-pdf-viewer": "^29.0.1",
    "ngx-gauge": "^13.0.0",
    "ngx-lottie": "^13.0.0",
    "ngx-mask": "^16.4.2",
    "ngx-nested-ellipsis": "^3.0.3",
    "ngx-pagination": "^6.0.3",
    "ngx-scrollbar": "^19.1.4",
    "ngx-toastr": "^20.0.5",
    "ngx-translate-messageformat-compiler": "^7.2.0",
    "normalize.css": "^8.0.1",
    "plyr": "3.7.8",
    "rxjs": "^7.8.0",
    "screenfull": "^5.0.2",
    "sendbird": "^3.0.142",
    "spark-md5": "^3.0.1",
    "swiper": "^11.1.15",
    "tslib": "^2.3.0",
    "uuid": "^8.3.2",
    "vanilla-cookieconsent": "^2.9.1",
    "videojs-record": "4.8.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.6",
    "@angular/build": "^22.1.6",
    "@angular/cli": "^22.1.6",
    "@angular/compiler-cli": "^22.1.4",
    "@angular/language-service": "^22.1.4",
    "@capacitor/cli": "6.2.1",
    "@types/dom-mediacapture-record": "1.0.13",
    "@types/jasmine": "~4.0.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "^20.17.0",
    "@types/spark-md5": "^3.0.2",
    "bootstrap": "^4.3.1",
    "cross-env": "^7.0.3",
    "dotenv": "^16.0.0",
    "form-data": "^3.0.0",
    "fs-jetpack": "^4.3.1",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.3.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "mv": "^2.1.1",
    "ng-packagr": "^22.1.1",
    "node-fetch": "^2.6.1",
    "phrase-js": "^1.0.10",
    "protractor": "~7.0.0",
    "replace-in-file": "^6.3.5",
    "rimraf": "^3.0.2",
    "ts-node": "~9.0.0",
    "typescript": "~6.0.3",
    "webpack-bundle-analyzer": "^4.2.0"
  },
  "resolutions": {
    "lodash": "4.18.1",
    "browserslist": "4.28.8"
  }
}
